module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_3-f5a822ea09c94ae6d2726dea5e3c377c.jpg";